var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _path7, _g7, _path8, _g8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcWhy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 25,
    viewBox: "0 0 41 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a3cpphgzca",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 11,
    width: 17,
    height: 14
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.53 14.753c4.77-.682 6.399 3.912 7.496 6.057 3.5 6.846 8.934 3.03 8.934 3.03-3.937-.228-4.96-5.535-6.36-7.573-2.256-3.284-4.242-4.306-5.841-4.306-2.643 0-4.23 2.792-4.23 2.792z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a3cpphgzca)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.632 4.022-7.055 21.827l17.912 13.769L24.544 17.79 6.632 4.022z",
    fill: "#162472"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "m3bg5wjelb",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 5,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.254 8.62s4.487-2.516 8.707 8.026c1.038 2.59 3.782 8.35 8.276 8.354h.012c1.096-.002 2.296-.346 3.6-1.16 0 0-3.452-.663-7.95-10.45-1.024-2.228-4.472-7.445-8.282-7.445-1.44 0-2.93.744-4.363 2.674",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#m3bg5wjelb)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.892-4.011-.953 17.923l22.158 17.016L38.05 13.005 15.892-4.01z",
    fill: "#162472"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "d7pkv5av5c",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 25,
    height: 24
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.336 0c-1.544.003-3.25.697-5.117 2.41 0 0 4.391-2.347 9.616 8.178 0 0 10.07 20.596 14.992 10.374 0 0-4.467 0-9.313-9.844C29.013 8.068 25.627.013 20.359 0h-.023z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#d7pkv5av5c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.358-11.89.15 19.602l30.537 23.473 24.208-31.492L24.358-11.89z",
    fill: "#162472"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "dfvbt7mh3d",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 0,
    width: 9,
    height: 10
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.331 9.074s1.666-.606 3.56.378c0 0 0-8.33-8.86-8.935 0 0 5.452 1.666 5.3 8.556",
    fill: "#fff"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#dfvbt7mh3d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m30.323-3.763-7.608 9.897 9.886 7.6 7.608-9.898-9.886-7.6z",
    fill: "#162472"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "f7uzwrp1re",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 33,
    y: 10,
    width: 8,
    height: 10
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.587 17.82c1.943 1.812 3.254 1.928 3.276 1.93h.008a9.28 9.28 0 0 0 .505-2.943v-.035c-.005-2.502-1.18-5.75-6.91-6.638 0 0 5.19 3.538 3.12 7.687",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#f7uzwrp1re)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.033 6.795-7.213 9.383 8.99 6.91 7.212-9.383-8.99-6.91z",
    fill: "#162472"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "shuubgr7zf",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15,
    width: 5,
    height: 10
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M0 17.327v.031c.003.422.144 5.06 4.695 7.011 0 0-3.786-4.164-1.59-8.556a5.29 5.29 0 0 0-1.018-.1c-.905 0-2.087.26-2.087 1.614z",
    fill: "#fff"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#shuubgr7zf)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.743 13.444-5.927 7.71 7.134 5.483 5.926-7.71-7.133-5.483z",
    fill: "#162472"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "1m9fwcwgng",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 9,
    width: 5,
    height: 6
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.422 11.497s1.59.682 3.105 2.574c0 0-.217-3.448.908-3.937 0 0-.89-.487-1.85-.487-.857 0-1.77.386-2.163 1.85z",
    fill: "#fff"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#1m9fwcwgng)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m8.912 7.708-3.629 4.72 4.66 3.582 3.629-4.72-4.66-3.582z",
    fill: "#162472"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "s8w20wzrwh",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 3,
    width: 7,
    height: 4
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.477 4.985s2.65.379 3.861 1.817c0 0 .303-1.665 1.742-2.65 0 0-1.319-.834-2.785-.834-.993 0-2.054.383-2.818 1.667z",
    fill: "#fff"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#s8w20wzrwh)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15.555.61-3.762 4.898L17 9.507l3.762-4.899L15.555.609z",
    fill: "#162472"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWhy);
export default __webpack_public_path__ + "static/media/ic_why.29190eeebf095bb6761836363c17b084.svg";
export { ForwardRef as ReactComponent };